import { Component } from 'react'
import { IClientUID } from '../../../api/clients'
import { clientPourAction, PourActionType } from '../../../api/0x0003/pour-action'
import { toast } from 'react-toastify'
import classNames from 'classnames'
import { FaHandPointDown, FaPlay, FaStop, FaCogs, FaEraser, FaSync, FaTint, FaBolt, FaWaveSquare, FaCog } from 'react-icons/fa'
import { askPersistentMap } from '../../../window/ask-persistent-map'
import { persistentMapAction, PersistentMapActionType } from '../../../api/0x0003/persistent-map'
import { restartClient } from '../../../api/0x0001/restart'
import { askYesNo } from '../../../window/ask-yes-no'
import { Window } from '../../../window'
import { ShowLoading } from '../../../window/show-loading'
import { getString } from '../../../locale'
import { askNumber } from '../../../window/ask-number'

const settingNameMap: Record<string, string> = {
    relsol_water: 'מספר רלסול עבור מים',
    relsol_soda: 'מספר רלסול עבור סודה',
    'flavor_io.0': 'מספר IO עבור טעם 1',
    'flavor_io.1': 'מספר IO עבור טעם 2',
    'flavor_io.2': 'מספר IO עבור טעם 3',
    'flavor_io.3': 'מספר IO עבור טעם 4',
    '0.up_duration': 'משך הפולס הגבוה (ms) - טעם 1 מים',
    '0.down_duration': 'משך הפולס הנמוך (ms) - טעם 1 מים',
    '0.start_delay': 'השהיית התחלה (ms) - טעם 1 מים',
    '0.stop_delay': 'השהיית סיום (ms) - טעם 1 מים',
    '2.up_duration': 'משך הפולס הגבוה (ms) - טעם 2 מים',
    '2.down_duration': 'משך הפולס הנמוך (ms) - טעם 2 מים',
    '2.start_delay': 'השהיית התחלה (ms) - טעם 2 מים',
    '2.stop_delay': 'השהיית סיום (ms) - טעם 2 מים',
    '4.up_duration': 'משך הפולס הגבוה (ms) - טעם 3 מים',
    '4.down_duration': 'משך הפולס הנמוך (ms) - טעם 3 מים',
    '4.start_delay': 'השהיית התחלה (ms) - טעם 3 מים',
    '4.stop_delay': 'השהיית סיום (ms) - טעם 3 מים',
    '6.up_duration': 'משך הפולס הגבוה (ms) - טעם 4 מים',
    '6.down_duration': 'משך הפולס הנמוך (ms) - טעם 4 מים',
    '6.start_delay': 'השהיית התחלה (ms) - טעם 4 מים',
    '6.stop_delay': 'השהיית סיום (ms) - טעם 4 מים',
    '1.up_duration': 'משך הפולס הגבוה (ms) - טעם 1 סודה',
    '1.down_duration': 'משך הפולס הנמוך (ms) - טעם 1 סודה',
    '1.start_delay': 'השהיית התחלה (ms) - טעם 1 סודה',
    '1.stop_delay': 'השהיית סיום (ms) - טעם 1 סודה',
    '3.up_duration': 'משך הפולס הגבוה (ms) - טעם 2 סודה',
    '3.down_duration': 'משך הפולס הנמוך (ms) - טעם 2 סודה',
    '3.start_delay': 'השהיית התחלה (ms) - טעם 2 סודה',
    '3.stop_delay': 'השהיית סיום (ms) - טעם 2 סודה',
    '5.up_duration': 'משך הפולס הגבוה (ms) - טעם 3 סודה',
    '5.down_duration': 'משך הפולס הנמוך (ms) - טעם 3 סודה',
    '5.start_delay': 'השהיית התחלה (ms) - טעם 3 סודה',
    '5.stop_delay': 'השהיית סיום (ms) - טעם 3 סודה',
    '7.up_duration': 'משך הפולס הגבוה (ms) - טעם 4 סודה',
    '7.down_duration': 'משך הפולס הנמוך (ms) - טעם 4 סודה',
    '7.start_delay': 'השהיית התחלה (ms) - טעם 4 סודה',
    '7.stop_delay': 'השהיית סיום (ms) - טעם 4 סודה',
    'calib.0_svt': 'זמן עצירת תקינות משאבה 1 (ms)',
    'calib.0_lst': 'תוצאת משאבה 1 (ms)',
    'calib.0_ml': 'כמות מים עבור משאבה 1 (ml)',
    'calib.0_mlsec': 'ספיקה עבור משאבה 1 (ml/sec)',
    'calib.1_svt': 'זמן עצירת תקינות משאבה 2 (ms)',
    'calib.1_lst': 'תוצאת משאבה 2 (ms)',
    'calib.1_ml': 'כמות מים עבור משאבה 2 (ml)',
    'calib.1_mlsec': 'ספיקה עבור משאבה 2 (ml/sec)',
    'calib.2_svt': 'זמן עצירת תקינות משאבה 3 (ms)',
    'calib.2_lst': 'תוצאת משאבה 3 (ms)',
    'calib.2_ml': 'כמות מים עבור משאבה 3 (ml)',
    'calib.2_mlsec': 'ספיקה עבור משאבה 3 (ml/sec)',
    'calib.3_svt': 'זמן עצירת תקינות משאבה 4 (ms)',
    'calib.3_lst': 'תוצאת משאבה 4 (ms)',
    'calib.3_ml': 'כמות מים עבור משאבה 4 (ml)',
    'calib.3_mlsec': 'ספיקה עבור משאבה 4 (ml/sec)',
    'calib.100_svt': 'זמן עצירת תקינות מים (ms)',
    'calib.100_lst': 'תוצאת מים (ms)',
    'calib.100_ml': 'כמות מים עבור מים (ml)',
    'calib.100_mlsec': 'ספיקה עבור מים (ml/sec)',
    'calib.101_svt': 'זמן עצירת תקינות סודה (ms)',
    'calib.101_lst': 'תוצאת סודה (ms)',
    'calib.101_ml': 'כמות מים עבור סודה (ml)',
    'calib.101_mlsec': 'ספיקה עבור סודה (ml/sec)',
}

const Flavors = ['טעם 1', 'טעם 2', 'טעם 3', 'טעם 4']

const Relsols = ['מים', 'סודה']

const Pumps = ['משאבה 1', 'משאבה 2', 'משאבה 3', 'משאבה 4', 'מים', 'סודה']

interface EnhancedPersistentMapEntry {
    key: string
    value: string
    name: string
    category: string
    type?: 'text' | 'number'
    validation?: {
        min?: number
        max?: number
        // required?: boolean; // Future: Add more validation as needed
    }
    changed?: boolean // Keep track of changes
}

type Props = {
    clientId: IClientUID
}

type State = {
    water: boolean
    soda: boolean
    flavor0water: boolean
    flavor0soda: boolean
    flavor1water: boolean
    flavor1soda: boolean
    flavor2water: boolean
    flavor2soda: boolean
    flavor3water: boolean
    flavor3soda: boolean
    calibration0: boolean
    calibration1: boolean
    calibration2: boolean
    calibration3: boolean
    calibration100: boolean
    calibration101: boolean
}

class SyrupTab extends Component<Props, State> {
    state: State = {
        water: false,
        soda: false,
        flavor0water: false,
        flavor0soda: false,
        flavor1water: false,
        flavor1soda: false,
        flavor2water: false,
        flavor2soda: false,
        flavor3water: false,
        flavor3soda: false,
        calibration0: false,
        calibration1: false,
        calibration2: false,
        calibration3: false,
        calibration100: false,
        calibration101: false,
    }

    settings: Array<{ key: string; value: string; name: string }> | undefined = undefined
    keepAliveIntervals: Map<string, NodeJS.Timeout> = new Map()

    componentDidMount = async () => {
        document.addEventListener('keypress', this.keyPressEventListener)
        this.loadSettings()
    }

    loadSettings = () => {
        return ShowLoading(getString('common.loading'), async () => {
            try {
                const entries = await persistentMapAction(this.props.clientId, PersistentMapActionType.GetValues)
                this.settings = (entries.data as any as Array<{ key: string; value: string }>).map(entry => {
                    return {
                        key: entry.key,
                        value: entry.value,
                        name: settingNameMap[entry.key] || entry.key,
                    }
                })
                console.log('settings', this.settings)
            } catch (err) {
                console.error(err)
                toast.error((err as Error).message)
            }
        })
    }

    componentWillUnmount = () => {
        document.removeEventListener('keypress', this.keyPressEventListener)

        for (const key in this.state) {
            if (this.state[key as keyof State]) {
                const flavor = key === 'water' || key === 'soda' ? 100 : Number(key.replace('flavor', '').replace('water', '').replace('soda', ''))
                const soda = key.includes('soda')
                const update = {
                    type: PourActionType.Stop,
                    flavor,
                    soda,
                }
                clientPourAction(this.props.clientId, update)
            }
        }
        this.keepAliveIntervals.forEach(interval => clearInterval(interval))
    }

    eraseAllSettings = async () => {
        if (!(await askYesNo('האם אתה בטוח שברצונך לאפס את כל ההגדרות?'))) return

        try {
            await persistentMapAction(this.props.clientId, PersistentMapActionType.Clear)
            toast.success('ההגדרות אופסו בהצלחה. מאתחל מחדש את המכונה.')
            await restartClient(this.props.clientId)
            this.settings = undefined
            await this.loadSettings()
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    keyPressEventListener = (event: KeyboardEvent) => {
        const key = Number(event.key)
        if (isNaN(key) || key < 0 || key > 9) return

        let flavor: number
        let soda: boolean

        if (key <= 1) {
            flavor = 100
            soda = key === 1
        } else {
            flavor = Math.floor((key - 2) / 2)
            soda = (key - 2) % 2 === 1
        }

        const stateKey = flavor === 100 ? (soda ? 'soda' : 'water') : (`flavor${flavor}${soda ? 'soda' : 'water'}` as keyof State)

        if (!Object.keys(this.state).includes(stateKey)) return

        const pressing = this.state[stateKey]

        console.log('key', event.key, 'flavor', flavor, 'soda', soda, 'stateKey', stateKey)

        if (pressing) {
            this.handleRelease(flavor, soda)
        } else {
            this.handlePress(flavor, soda)
        }
    }

    handleKeepAlive = async (flavor: number, soda: boolean) => {
        const suffix = soda ? 'soda' : 'water'
        const key = (flavor === 100 ? (soda ? 'soda' : 'water') : `flavor${flavor}${suffix}`) as keyof State
        try {
            const startedAt = Date.now()

            await clientPourAction(this.props.clientId, {
                type: PourActionType.KeepAlive,
                flavor,
                soda,
            })

            if (Date.now() - startedAt > 2000) {
                toast.warning('אותרה תקלה. Keep alive לא עבר בהצלחה.')
                this.setState({ [key]: false } as any)

                clearInterval(this.keepAliveIntervals.get(key)!)
                this.keepAliveIntervals.delete(key)
                return
            }

            const keepAlive = setTimeout(() => this.handleKeepAlive(flavor, soda), 333)
            this.keepAliveIntervals.set(key, keepAlive)
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)

            this.setState({ [key]: false } as any)
            if (this.keepAliveIntervals.has(key)) {
                clearInterval(this.keepAliveIntervals.get(key)!)
                this.keepAliveIntervals.delete(key)
            }
        }
    }

    handlePress = (flavor: number, soda: boolean) => {
        try {
            const suffix = soda ? 'soda' : 'water'
            const key = (flavor === 100 ? (soda ? 'soda' : 'water') : `flavor${flavor}${suffix}`) as keyof State
            const pressing = this.state[key]

            console.log('flavor', flavor, 'soda', soda, 'key', key, 'pressing', pressing)

            if (!pressing) {
                const update = {
                    type: PourActionType.Start,
                    flavor,
                    soda,
                }
                clientPourAction(this.props.clientId, update)
                this.setState({ [key]: true } as any)

                if (this.keepAliveIntervals.has(key)) {
                    clearInterval(this.keepAliveIntervals.get(key)!)
                    this.keepAliveIntervals.delete(key)
                }

                const keepAlive = setTimeout(() => this.handleKeepAlive(flavor, soda), 333)
                this.keepAliveIntervals.set(key, keepAlive)
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelease = (flavor: number, soda: boolean) => {
        try {
            const suffix = soda ? 'soda' : 'water'
            const key = (flavor === 100 ? (soda ? 'soda' : 'water') : `flavor${flavor}${suffix}`) as keyof State
            const pressing = this.state[key]

            console.log('flavor', flavor, 'soda', soda, 'key', key, 'pressing', pressing)

            if (pressing) {
                const update = {
                    type: PourActionType.Stop,
                    flavor,
                    soda,
                }
                clientPourAction(this.props.clientId, update)
                this.setState({ [key]: false } as any)

                if (this.keepAliveIntervals.has(key)) {
                    clearInterval(this.keepAliveIntervals.get(key)!)
                    this.keepAliveIntervals.delete(key)
                }
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    showSettingsForm = async (flavor: number, soda: boolean) => {
        if (!this.settings) {
            await this.loadSettings()
            if (!this.settings) {
                toast.error('לא ניתן לטעון הגדרות.')
                return
            }
        }

        const pourKey = flavor === 100 ? (soda ? '101' : '100') : (flavor << 1) | (soda ? 1 : 0)
        const flavorIoKey = `flavor_io.${flavor}`

        const toShow = JSON.parse(
            JSON.stringify(
                this.settings!.filter(entry => {
                    const s = entry.key.split('.')
                    if (s.length === 2) {
                        const k = s[0]
                        return String(pourKey) === k || (flavor < 100 && entry.key === flavorIoKey)
                    }
                    return false
                }),
            ),
        )

        if (toShow.length === 0 && flavor < 100) {
            const flavorIoSetting = this.settings!.find(s => s.key === flavorIoKey)
            if (flavorIoSetting) {
                toShow.push(JSON.parse(JSON.stringify(flavorIoSetting)))
            } else {
                toShow.push({ key: flavorIoKey, value: '', name: settingNameMap[flavorIoKey] || flavorIoKey })
            }
        }

        try {
            document.removeEventListener('keypress', this.keyPressEventListener)
            const { value: entries, isConfirmed } = await askPersistentMap(toShow, {
                title: `הגדרות ${flavor < 100 ? Flavors[flavor] : ''} ${soda ? Relsols[1] : Relsols[0]}`,
            })
            if (isConfirmed) {
                await persistentMapAction(
                    this.props.clientId,
                    PersistentMapActionType.SetValues,
                    entries
                        .filter((entry: { key: string; value: string; changed: boolean }) => entry.changed)
                        .map((entry: { key: string; value: string }) => {
                            return {
                                key: entry.key,
                                value: entry.value,
                            }
                        }),
                )
                for (const entry of entries.filter((e: any) => e.changed)) {
                    const settingIndex = this.settings!.findIndex(e => e.key === entry.key)
                    if (settingIndex !== -1) {
                        this.settings![settingIndex].value = entry.value
                    } else {
                        this.settings!.push({ key: entry.key, value: entry.value, name: settingNameMap[entry.key] || entry.key })
                    }
                }
                toast.success('ההגדרות נשמרו בהצלחה.')
            }
        } finally {
            document.addEventListener('keypress', this.keyPressEventListener)
        }
    }

    showGlobalSettingsForm = async () => {
        if (!this.settings) {
            await this.loadSettings()
            if (!this.settings) {
                toast.error('לא ניתן לטעון הגדרות.')
                return
            }
        }

        const keysToRemove = ['hz', 'calib.0_pwm', 'calib.1_pwm', 'calib.2_pwm', 'calib.3_pwm', 'calib.100_pwm', 'calib.101_pwm']

        const filteredRawSettings = this.settings!.filter(entry => !keysToRemove.includes(entry.key) && !entry.key.startsWith('calib.'))

        const categorizedEntries: EnhancedPersistentMapEntry[] = filteredRawSettings.map(entry => {
            const enhancedEntry: EnhancedPersistentMapEntry = {
                ...entry,
                name: settingNameMap[entry.key] || entry.key,
                category: 'לא ידוע',
                type: 'text',
            }

            if (entry.key.startsWith('relsol_')) {
                enhancedEntry.category = 'Relsol Configuration'
                enhancedEntry.type = 'number'
                enhancedEntry.validation = { min: 0 }
            } else if (entry.key.startsWith('flavor_io.')) {
                enhancedEntry.category = 'Flavor IO Pins'
                enhancedEntry.type = 'number'
                enhancedEntry.validation = { min: 0 }
            } else if (entry.key.match(/^\\d+\\.(up_duration|down_duration|start_delay|stop_delay)$/)) {
                const keyPrefix = parseInt(entry.key.split('.')[0], 10)
                enhancedEntry.category = keyPrefix % 2 === 0 ? 'Pour Pulse Defaults - Water' : 'Pour Pulse Defaults - Soda'
                enhancedEntry.type = 'number'
                enhancedEntry.validation = { min: 0 }
            }
            return enhancedEntry
        })

        const categoryOrder = ['Relsol Configuration', 'Flavor IO Pins', 'Pour Pulse Defaults - Water', 'Pour Pulse Defaults - Soda', 'לא ידוע']

        const originalOrderMap = new Map(filteredRawSettings.map((s, i) => [s.key, i]))

        categorizedEntries.sort((a, b) => {
            const categoryIndexA = categoryOrder.indexOf(a.category)
            const categoryIndexB = categoryOrder.indexOf(b.category)

            if (categoryIndexA !== categoryIndexB) {
                return categoryIndexA - categoryIndexB
            }
            const originalIndexA = originalOrderMap.get(a.key) ?? Infinity
            const originalIndexB = originalOrderMap.get(b.key) ?? Infinity
            return originalIndexA - originalIndexB
        })

        const toShow = JSON.parse(JSON.stringify(categorizedEntries.filter(e => e.category !== 'לא ידוע')))

        if (toShow.length === 0) {
            toast.info('לא נמצאו הגדרות גלובליות להצגה.')
            return
        }

        try {
            document.removeEventListener('keypress', this.keyPressEventListener)
            const { value: returnedEntries, isConfirmed } = await askPersistentMap(toShow, { title: 'הגדרות מערכת ומיפויים' })
            if (isConfirmed && returnedEntries) {
                const changesToApply = returnedEntries
                    .filter((entry: EnhancedPersistentMapEntry) => entry.changed)
                    .map((entry: EnhancedPersistentMapEntry) => ({
                        key: entry.key,
                        value: entry.value,
                    }))

                if (changesToApply.length > 0) {
                    await persistentMapAction(this.props.clientId, PersistentMapActionType.SetValues, changesToApply)
                    for (const changedEntry of changesToApply) {
                        const mainSettingIndex = this.settings!.findIndex(s => s.key === changedEntry.key)
                        if (mainSettingIndex !== -1) {
                            this.settings![mainSettingIndex].value = changedEntry.value
                        }
                    }
                    toast.success('הגדרות נשמרו בהצלחה.')
                } else {
                    toast.info('לא בוצעו שינויים.')
                }
            }
        } finally {
            document.addEventListener('keypress', this.keyPressEventListener)
        }
    }

    showPumpCalibrationSettingsForm = async (pumpId: number, pumpName: string) => {
        if (!this.settings) {
            await this.loadSettings()
            if (!this.settings) {
                toast.error('לא ניתן לטעון הגדרות.')
                return
            }
        }

        const pumpCalibSettings = this.settings!.filter(entry => entry.key.startsWith(`calib.${pumpId}_`) && !entry.key.endsWith('_pwm')).map(
            entry => {
                const enhancedEntry: EnhancedPersistentMapEntry = {
                    ...entry,
                    name: settingNameMap[entry.key] || entry.key,
                    category: 'נתוני כיול',
                    type: 'number',
                    validation: { min: 0 },
                }
                if (entry.key.endsWith('_mlsec')) {
                    // ml/sec can be a float and might be read-only if calculated, but allow editing for now
                }
                return enhancedEntry
            },
        )

        if (pumpCalibSettings.length === 0) {
            toast.info(`לא נמצאו הגדרות כיול עבור ${pumpName}.`)
            return
        }

        const sortOrder = ['ml', 'svt', 'lst', 'mlsec']
        pumpCalibSettings.sort((a, b) => {
            const suffixA = a.key.substring(a.key.lastIndexOf('_') + 1)
            const suffixB = b.key.substring(b.key.lastIndexOf('_') + 1)
            return sortOrder.indexOf(suffixA) - sortOrder.indexOf(suffixB)
        })

        try {
            document.removeEventListener('keypress', this.keyPressEventListener)
            const { value: returnedEntries, isConfirmed } = await askPersistentMap(JSON.parse(JSON.stringify(pumpCalibSettings)), {
                title: `הגדרות כיול - ${pumpName}`,
            })

            if (isConfirmed && returnedEntries) {
                const changesToApply = returnedEntries
                    .filter((entry: EnhancedPersistentMapEntry) => entry.changed)
                    .map((entry: EnhancedPersistentMapEntry) => ({
                        key: entry.key,
                        value: entry.value,
                    }))

                if (changesToApply.length > 0) {
                    await persistentMapAction(this.props.clientId, PersistentMapActionType.SetValues, changesToApply)
                    for (const changedEntry of changesToApply) {
                        const mainSettingIndex = this.settings!.findIndex(s => s.key === changedEntry.key)
                        if (mainSettingIndex !== -1) {
                            this.settings![mainSettingIndex].value = changedEntry.value
                        }
                    }
                    toast.success(`הגדרות כיול עבור ${pumpName} נשמרו.`)
                } else {
                    toast.info('לא בוצעו שינויים.')
                }
            }
        } finally {
            document.addEventListener('keypress', this.keyPressEventListener)
        }
    }

    handlePumpCalibrationBegin = async (pump: number) => {
        try {
            this.setState({ [`calibration${pump}`]: true } as any)

            const update = {
                type: PourActionType.BeginCalibration,
                pump,
            }
            const result = await clientPourAction(this.props.clientId, update)
            console.log('calibration result', result)
            const { isConfirmed } = await new Window().fire({
                title: 'תוצאות קליברציה',
                showCancelButton: true,
                cancelButtonColor: 'gray',
                cancelButtonText: 'סגור',
                showConfirmButton: result.data?.error === 0,
                confirmButtonText: 'עדכן הגדרות קליברציה',
                confirmButtonColor: 'green',
                body: (
                    <div className="text-right">
                        {pump <= 3 ? (
                            <div className="mb-4">
                                <h2 className="text-xl font-semibold">משאבה {pump + 1}</h2>
                            </div>
                        ) : (
                            <div className="mb-4">
                                <h2 className="text-xl font-semibold">{pump === 100 ? 'מים' : 'סודה'}</h2>
                            </div>
                        )}
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                        שגיאה
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        זמן פעולה (ms)
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        PWM (%)
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        זמן עצירת תקינות (ms)
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                    <td className="px-6 py-4">{result.data?.error === 0 ? 'אין שגיאה' : result.data?.error}</td>
                                    <td className="px-6 py-4">{result.data?.lasted}</td>
                                    <td className="px-6 py-4">{result.data?.pwm}</td>
                                    <td className="px-6 py-4">{result.data?.stopValidationTime}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                ),
            })
            if (isConfirmed) {
                await ShowLoading('מעדכן...', async () => {
                    try {
                        await clientPourAction(this.props.clientId, {
                            type: PourActionType.CalibrationApproval,
                            key: pump,
                            lasted: result.data?.lasted,
                        })

                        if (this.settings) {
                            const lastedSettingKey = `calib.${pump}_lst`
                            const mlSettingKey = `calib.${pump}_ml`
                            const pwmSettingKey = `calib.${pump}_pwm`
                            const svtSettingKey = `calib.${pump}_svt`

                            const lastedEntry = this.settings.find(e => e.key === lastedSettingKey)
                            if (lastedEntry) lastedEntry.value = String(result.data?.lasted)
                            else
                                this.settings.push({
                                    key: lastedSettingKey,
                                    value: String(result.data?.lasted),
                                    name: settingNameMap[lastedSettingKey] || lastedSettingKey,
                                })

                            const pwmEntry = this.settings.find(e => e.key === pwmSettingKey)
                            if (pwmEntry) pwmEntry.value = String(result.data?.pwm)
                            else
                                this.settings.push({
                                    key: pwmSettingKey,
                                    value: String(result.data?.pwm),
                                    name: settingNameMap[pwmSettingKey] || pwmSettingKey,
                                })

                            const svtEntry = this.settings.find(e => e.key === svtSettingKey)
                            if (svtEntry) svtEntry.value = String(result.data?.stopValidationTime)
                            else
                                this.settings.push({
                                    key: svtSettingKey,
                                    value: String(result.data?.stopValidationTime),
                                    name: settingNameMap[svtSettingKey] || svtSettingKey,
                                })

                            const mlEntry = this.settings.find(e => e.key === mlSettingKey)
                            if (mlEntry && result.data?.lasted && Number(result.data?.lasted) > 0) {
                                const ml = Number(mlEntry.value)
                                const lastedMs = Number(result.data.lasted)
                                if (!isNaN(ml) && !isNaN(lastedMs) && lastedMs > 0) {
                                    const mlSec = (ml / (lastedMs / 1000)).toFixed(2)
                                    const mlSecKey = `calib.${pump}_mlsec`
                                    const mlSecEntry = this.settings.find(e => e.key === mlSecKey)
                                    if (mlSecEntry) mlSecEntry.value = mlSec
                                    else this.settings.push({ key: mlSecKey, value: mlSec, name: settingNameMap[mlSecKey] || mlSecKey })

                                    await persistentMapAction(this.props.clientId, PersistentMapActionType.SetValues, [
                                        { key: mlSecKey, value: mlSec },
                                    ])
                                }
                            }
                        }
                        toast.success('נתוני קליברציה עודכנו בהצלחה.')
                    } catch (err) {
                        console.error(err)
                        toast.error((err as Error).message)
                    }
                })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        } finally {
            this.setState({ [`calibration${pump}`]: false } as any)
        }
    }

    handlePumpCalibrationInterrupt = async (pump: number) => {
        try {
            const update = {
                type: PourActionType.InterruptCalibration,
                pump,
            }
            await clientPourAction(this.props.clientId, update)
            this.setState({ [`calibration${pump}`]: false } as any)
            toast.info('כיול הופסק.')
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleSync = async (flavor: number, soda: boolean) => {
        if (!this.settings) {
            await this.loadSettings()
            if (!this.settings) {
                toast.error('לא ניתן לטעון הגדרות לצורך סנכרון.')
                return
            }
        }

        const calibPumpKey = flavor >= 100 ? (soda ? 101 : 100) : flavor

        const intervalDuration = await askNumber('משך פולס בסיס לסנכרון (ms)?', 1000)
        if (intervalDuration === undefined || intervalDuration <= 0) {
            if (intervalDuration !== undefined) toast.error('משך הפולס חייב להיות גדול מאפס.')
            return
        }

        const waterSodaCupsPerJuiceCup = await askNumber('יחס רצוי (כוסות מים/סודה לכל כוס מיץ בודדת)?', 6)
        if (waterSodaCupsPerJuiceCup === undefined || waterSodaCupsPerJuiceCup <= 0) {
            if (waterSodaCupsPerJuiceCup !== undefined) toast.error('יחס הכוסות חייב להיות גדול מאפס.')
            return
        }

        const pourKey = flavor === 100 ? (soda ? '1' : '0') : (flavor << 1) | (soda ? 1 : 0)

        const getCalibrationValue = (pumpIdx: number, suffix: 'ml' | 'lst' | 'mlsec'): number | undefined => {
            const val = this.settings!.find(e => e.key === `calib.${pumpIdx}_${suffix}`)?.value
            return val ? Number(val) : undefined
        }

        const juiceMlSec = getCalibrationValue(calibPumpKey, 'mlsec')
        const relsolCalibPumpKey = soda ? 101 : 100
        const relsolMlSec = getCalibrationValue(relsolCalibPumpKey, 'mlsec')

        if (juiceMlSec === undefined || relsolMlSec === undefined) {
            let missing = []
            if (juiceMlSec === undefined) missing.push(flavor < 100 ? Pumps[calibPumpKey] : soda ? Relsols[1] : Relsols[0])
            if (relsolMlSec === undefined) missing.push(soda ? Relsols[1] : Relsols[0])
            toast.error(`חסרים נתוני קליברציה (ml/sec) עבור: ${missing.join(', ')}. בצע קליברציה תחילה.`)
            return
        }
        if (juiceMlSec <= 0 || relsolMlSec <= 0) {
            toast.error(`נתוני ספיקה (ml/sec) חייבים להיות גדולים מאפס. בצע קליברציה מחדש.`)
            return
        }

        const totalRelsolVolumeForRatio = juiceMlSec * waterSodaCupsPerJuiceCup
        const juicePourTime = intervalDuration

        const targetJuiceToRelsolRatio = 1 / waterSodaCupsPerJuiceCup
        const actualThroughputRatio = juiceMlSec / relsolMlSec

        let juiceOnFraction = relsolMlSec / juiceMlSec / waterSodaCupsPerJuiceCup

        if (juiceOnFraction > 1) {
            toast.warn('אזהרה: יחס הספיקות והיחס הרצוי דורשים שהמיץ יזרום יותר מ-100% מהזמן. מגביל ל-100%. שקול לשנות יחס כוסות או לכייל מחדש.')
            juiceOnFraction = 1
        }
        if (juiceOnFraction <= 0) {
            toast.error('שגיאה: יחס הספיקות והיחס הרצוי דורשים שהמיץ יזרום 0% או פחות מהזמן. בדוק קליברציה ויחס מבוקש.')
            return
        }

        const upDurationMs = Math.floor(intervalDuration * juiceOnFraction)
        const downDurationMs = intervalDuration - upDurationMs

        console.log('Sync params:', { flavor, soda, calibPumpKey, intervalDuration, waterSodaCupsPerJuiceCup, pourKey })
        console.log('Sync values:', {
            juiceMlSec,
            relsolMlSec,
            targetJuiceToRelsolRatio,
            actualThroughputRatio,
            juiceOnFraction,
            upDurationMs,
            downDurationMs,
        })

        if (isNaN(upDurationMs) || isNaN(downDurationMs) || upDurationMs < 0 || downDurationMs < 0) {
            toast.error('הזמנים שנקבעו אינם חוקיים. בדוק את נתוני הקליברציה והיחס המבוקש.')
            return
        }
        if (upDurationMs === 0 && downDurationMs === 0 && intervalDuration > 0) {
            toast.error('הזמנים שנקבעו הם אפס. בדוק את נתוני הקליברציה והיחס המבוקש.')
            return
        }

        try {
            const settingsToUpdate = [
                {
                    key: `${pourKey}.up_duration`,
                    value: String(upDurationMs),
                },
                {
                    key: `${pourKey}.down_duration`,
                    value: String(downDurationMs),
                },
            ]
            await persistentMapAction(this.props.clientId, PersistentMapActionType.SetValues, settingsToUpdate)

            if (this.settings) {
                settingsToUpdate.forEach(setting => {
                    const entry = this.settings!.find(e => e.key === setting.key)
                    if (entry) {
                        entry.value = setting.value
                    } else {
                        this.settings!.push({ ...setting, name: settingNameMap[setting.key] || setting.key })
                    }
                })
            }

            toast.success('הגדרות סנכרון פולסים נשמרו בהצלחה.')
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    render() {
        return (
            <div className="p-4 bg-gray-100 dark:bg-gray-900 min-h-screen text-gray-800 dark:text-white">
                <header className="mb-6">
                    <div className="flex justify-center items-center mt-4 space-x-3 rtl:space-x-reverse">
                        <button
                            title="איפוס כל ההגדרות"
                            className="p-3 text-white rounded-full bg-red-500 hover:bg-red-700 transition-colors shadow-lg ml-3"
                            onClick={this.eraseAllSettings}
                        >
                            <FaEraser size={20} />
                        </button>
                        <button
                            title="הגדרות כלליות"
                            className="p-3 text-white rounded-full bg-blue-500 hover:bg-blue-700 transition-colors shadow-lg ml-3"
                            onClick={this.showGlobalSettingsForm}
                        >
                            <FaCog size={20} />
                        </button>
                        <button
                            title="טען הגדרות מחדש"
                            className="p-3 text-white rounded-full bg-green-500 hover:bg-green-700 transition-colors shadow-lg ml-3"
                            onClick={this.loadSettings}
                        >
                            <FaSync size={20} />
                        </button>
                    </div>
                </header>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4 text-center">בקרת מזיגה</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md">
                            <h3 className="text-xl font-medium mb-3 text-center border-b pb-2 dark:border-gray-700">נוזלים בסיסיים</h3>
                            {Relsols.map((name, index) => this.renderRow(name, 100, index === 1, `relsol-${index}`))}
                        </div>

                        {Flavors.map((flavorName, flavorIndex) => (
                            <div key={`flavor-section-${flavorIndex}`} className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md">
                                <h3 className="text-xl font-medium mb-3 text-center border-b pb-2 dark:border-gray-700">{flavorName}</h3>
                                {Relsols.map((relsolName, relsolIndex) =>
                                    this.renderRow(
                                        `${relsolName}`,
                                        flavorIndex,
                                        relsolIndex === 1,
                                        `flavor-${flavorIndex}-relsol-${relsolIndex}`,
                                        flavorName,
                                    ),
                                )}
                            </div>
                        ))}
                    </div>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold mb-4 text-center">כיול משאבות</h2>
                    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                            {Pumps.map((name, index) => this.renderPumpRow(name, index, `pump-${index}`))}
                        </div>
                    </div>
                </section>
                <footer className="mt-8 text-center text-sm text-gray-500 dark:text-gray-400">ניתן להשתמש במקשים 0-9 למזיגה מהירה.</footer>
            </div>
        )
    }

    renderRow(displayName: string, flavorOrBaseId: number, isSoda: boolean, keySuffix: string, mainFlavorName?: string) {
        const isBaseLiquid = flavorOrBaseId === 100
        const stateKey = isBaseLiquid ? (isSoda ? 'soda' : 'water') : (`flavor${flavorOrBaseId}${isSoda ? 'soda' : 'water'}` as keyof State)
        const pressing = this.state[stateKey]

        const pourButtonText = pressing ? <FaStop size={18} /> : <FaHandPointDown size={18} />
        const pourButtonColor = pressing ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600'

        const liquidIcon = isSoda ? <FaBolt className="text-blue-400" /> : <FaTint className="text-blue-500" />
        const displayTitle = mainFlavorName ? `${mainFlavorName} (${displayName})` : displayName

        let keyboardShortcutKey = -1
        if (isBaseLiquid) {
            keyboardShortcutKey = isSoda ? 1 : 0
        } else {
            keyboardShortcutKey = 2 + flavorOrBaseId * 2 + (isSoda ? 1 : 0)
        }

        return (
            <div
                key={keySuffix}
                className="flex flex-col sm:flex-row justify-between items-center p-3 mb-2 bg-gray-50 dark:bg-gray-700 rounded-md shadow"
            >
                <div className="flex items-center mb-2 sm:mb-0 rtl:mr-2 ltr:ml-2">
                    {liquidIcon}
                    <span className="ms-2 me-2 text-lg font-medium">{displayTitle}</span>
                    {keyboardShortcutKey !== -1 && <span className="text-xs text-gray-500 dark:text-gray-400">({keyboardShortcutKey})</span>}
                </div>

                <div className="flex items-center space-x-2 rtl:space-x-reverse">
                    {!isBaseLiquid && (
                        <>
                            <button
                                title={`סנכרון פולסים ל${displayTitle}`}
                                className="p-2 text-white rounded-full bg-purple-500 hover:bg-purple-600 transition-colors ml-2"
                                onClick={() => this.handleSync(flavorOrBaseId, isSoda)}
                            >
                                <FaWaveSquare size={16} />
                            </button>
                            <button
                                title={`הגדרות ${displayTitle}`}
                                className="p-2 text-white rounded-full bg-indigo-500 hover:bg-indigo-600 transition-colors ml-2"
                                onClick={() => this.showSettingsForm(flavorOrBaseId, isSoda)}
                            >
                                <FaCogs size={16} />
                            </button>
                        </>
                    )}
                    <button
                        title={pressing ? `הפסק מזיגת ${displayTitle}` : `התחל מזיגת ${displayTitle}`}
                        className={classNames(
                            'p-3 text-white rounded-full transition-colors font-semibold shadow-md min-w-[44px] flex justify-center items-center',
                            pourButtonColor,
                        )}
                        onMouseDown={() => this.handlePress(flavorOrBaseId, isSoda)}
                        onMouseUp={() => this.handleRelease(flavorOrBaseId, isSoda)}
                        onMouseLeave={() => this.handleRelease(flavorOrBaseId, isSoda)}
                        onTouchStart={e => {
                            e.preventDefault()
                            this.handlePress(flavorOrBaseId, isSoda)
                        }}
                        onTouchEnd={() => this.handleRelease(flavorOrBaseId, isSoda)}
                        onTouchCancel={() => this.handleRelease(flavorOrBaseId, isSoda)}
                    >
                        {pourButtonText}
                    </button>
                </div>
            </div>
        )
    }

    renderPumpRow(name: string, pumpIndexInPumpsArray: number, keySuffix: string) {
        const pumpId = pumpIndexInPumpsArray <= 3 ? pumpIndexInPumpsArray : pumpIndexInPumpsArray === 4 ? 100 : 101
        const stateKey = `calibration${pumpId}` as keyof State
        const calibrating = this.state[stateKey]

        const calibrationButtonText = calibrating ? <FaStop size={18} /> : <FaPlay size={18} />
        const calibrationButtonColor = calibrating ? 'bg-yellow-500 hover:bg-yellow-600' : 'bg-green-500 hover:bg-green-600'
        const calibrationAction = calibrating ? () => this.handlePumpCalibrationInterrupt(pumpId) : () => this.handlePumpCalibrationBegin(pumpId)

        return (
            <div
                key={keySuffix}
                className="flex flex-col sm:flex-row justify-between items-center p-3 mb-2 bg-gray-50 dark:bg-gray-700 rounded-md shadow"
            >
                <span className="text-lg font-medium mb-2 sm:mb-0 rtl:ml-2 ltr:mr-2">{name}</span>
                <div className="flex items-center space-x-2 rtl:space-x-reverse">
                    <button
                        title={`הגדרות כיול עבור ${name}`}
                        className="p-2 text-white rounded-full bg-indigo-500 hover:bg-indigo-600 transition-colors ml-2"
                        onClick={() => this.showPumpCalibrationSettingsForm(pumpId, name)}
                    >
                        <FaCogs size={16} />
                    </button>
                    <button
                        title={calibrating ? `הפסק כיול ${name}` : `התחל כיול ${name}`}
                        className={classNames(
                            'p-3 text-white rounded-full transition-colors font-semibold shadow-md min-w-[44px] flex justify-center items-center',
                            calibrationButtonColor,
                        )}
                        onClick={calibrationAction}
                    >
                        {calibrationButtonText}
                    </button>
                </div>
            </div>
        )
    }
}

export default SyrupTab
